(() => {
  if (customElements.get('mc-picker-tools')) return;
  customElements.define('mc-picker-tools', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      this.picker = this.closest('variant-selects');
      if (!this.picker) return;
      this.rows = [...this.querySelectorAll('.product-form__input--pill, .product-form__input--swatch')];
      const options = { signal: this.abort.signal };
      this.picker.addEventListener('change', () => window.mcSizePrices?.update(this.picker), { ...options, capture: true });
      this.addEventListener('click', event => {
        const button = event.target.closest('.mc-sl-arrow');
        const row = button?.parentElement.querySelector('fieldset');
        if (row) row.scrollBy({ left: Math.round(row.clientWidth * .7), behavior: 'smooth' });
      }, options);
      this.rows.forEach(row => row.addEventListener('scroll', () => this.placeArrow(row), { ...options, passive: true }));
      this.resize = new ResizeObserver(() => this.layout());
      this.rows.forEach(row => this.resize.observe(row));
      window.mcSizePrices?.update(this.picker);
      this.layout();
      this.dispatchEvent(new CustomEvent('mc:picker-ready', { bubbles: true }));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = this.resize = this.picker = this.rows = null;
    }
    layout() {
      if (!this.isConnected || !this.rows) return;
      this.rows.forEach(row => {
        if (!row.__mcArrow && matchMedia('(max-width: 1023.98px)').matches && row.scrollWidth > row.clientWidth + 2) {
          const wrap = document.createElement('div');
          wrap.className = 'mc-sl-wrap';
          row.before(wrap); wrap.append(row);
          const fade = document.createElement('div'); fade.className = 'mc-sl-fade';
          const button = document.createElement('button'); button.type = 'button'; button.className = 'mc-sl-arrow'; button.setAttribute('aria-label', this.dataset.moreLabel);
          button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
          wrap.append(fade, button); row.__mcWrap = wrap; row.__mcArrow = button; row.__mcFade = fade;
        }
        this.placeArrow(row);
      });
    }
    placeArrow(row) {
      if (!row.__mcArrow) return;
      const first = row.querySelector('label');
      if (first) {
        const box = row.__mcWrap.getBoundingClientRect(), label = first.getBoundingClientRect();
        row.__mcArrow.style.top = label.top - box.top + label.height / 2 + 'px';
        row.__mcFade.style.top = label.top - box.top + 'px'; row.__mcFade.style.height = label.height + 'px';
      }
      const end = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      row.__mcArrow.classList.toggle('mc-sl-hide', end); row.__mcFade.classList.toggle('mc-sl-hide', end);
    }
  });
})();
